"use client";

import React, { useEffect } from "react";
import { Button, FontIcon } from "@/app/_components";
import styles from "./RewardDialog.module.css";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {DriveUtil} from "@/Master/DriveUtil";

export interface RewardDialogProps extends SDialogProps {
    gcCount: number;
    scCount: number;
}

export const RewardDialogFC: React.FC<RewardDialogProps> = (props) => {
    const {fcKey, onClose,gcCount,scCount} = props;
    const {closeDialog} = useDialogMethods(fcKey);

    useEffect(() => {
        console.log("RewardDialog initialized");
        return () => {
            console.log("RewardDialog disposed");
        };
    }, []);

    const onClick = () => {
        closeDialog();
        onClose?.();
    }


    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            title="\n\n\n"
        >
            <section className={styles.layer}>
                <section className={styles.panel}></section>
                <section className={styles.top_wrapper}>
                    <img className={styles.light} src="/img/general-gift/img_light.webp" width="100%" alt="" />
                    <section className={styles.title}>CONGRATULATION!</section>
                </section>

                <section className={styles.container}>

                    {
                        scCount > 0 && (
                            <section className={`${styles.flex_reward} ${styles.flex_sc} center`}>
                                <img className={styles.img_gold} src="/img/ico_sc_big.png" alt=""/>
                                <div className={styles.sc_title}>{DriveUtil.ToScString(scCount,true)}</div>
                            </section>
                        )
                    }

                    {
                        gcCount > 0 && (
                            <section className={`${styles.flex_reward} ${styles.flex_gc} center`}>
                            <img className={styles.img_gold} src="/img/ico_gc_big.png" alt=""/>
                                <div className={styles.gc_title}>{DriveUtil.ToGcString(gcCount, true)}</div>
                            </section>
                        )
                    }

                </section>

                <section style={{textAlign: "center", marginTop: "1.9rem"}}>
                    <Button
                        color="#0090FF"
                        style={{
                            color: "#fff",
                            width: "5rem",
                            height: "1.15rem",
                            fontSize: ".6rem",
                            fontWeight: 900,
                        }}
                        onClick={onClick}
                    >
                        Claim
                    </Button>
                </section>
            </section>
        </SDialogFC>
    );
};
